var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserGroup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 423.12 311.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 216.42,
    y1: 248.78,
    x2: 434.88,
    y2: 361.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 128.9,
    y1: 187.45,
    x2: 162.69,
    y2: 157.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 64.78,
    y1: 202.49,
    x2: 67.69,
    y2: 164.66,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 106.57,
    y1: 178.66,
    x2: 105.37,
    y2: 232.8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 83.75,
    y1: 260.82,
    x2: 214.76,
    y2: 328.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 192.01,
    y1: 259.67,
    x2: 232.94,
    y2: 201.62,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 105.52,
    y1: 239.12,
    x2: 113.54,
    y2: 201.83,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 275.13,
    y1: 181.84,
    x2: 293.18,
    y2: 182.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -1863.28,
    y1: 182.04,
    x2: -1845.23,
    y2: 182.94,
    gradientTransform: "matrix(-1, 0, 0, 1, -1504.13, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 256.49,
    y1: 206.62,
    x2: 228.55,
    y2: 194.18,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 162.85,
    y1: 204.18,
    x2: 178.79,
    y2: 196.16,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 177.54,
    y1: 193.69,
    x2: 170.32,
    y2: 162.41,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 259.07,
    y1: 150.25,
    x2: 230.4,
    y2: 182.34,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 318.76,
    y1: 247.55,
    x2: 300.34,
    y2: 164.31,
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "User Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M27.55,305.57C-7.63,280.09,1.1,219.24,3.39,199.64c1.27-10.79,3.92-21.58,9.38-30.82C28.5,142.18,62,135.45,86.76,118c27.55-19.31,45.09-52.62,74.74-68.12,16.32-8.53,34.91-10.84,53.12-11.86,33.06-1.86,69.24,1.27,93.81,24.61,17.77,16.88,26.63,41.79,42.42,60.72,13.92,16.7,32.72,28.15,47.29,44.23,21.64,23.86,32.7,60.37,21,90.95-10.87,28.33-27.51,46.92-36.14,49.72-27.7,9-88.24,10.09-117.21,12.15-31.05,2.2-59-2.62-90.11-2.52-48,.16-113.49,2.81-148.09-12.35",
    transform: "translate(-0.75 -37.61)",
    fill: "#2c7be5",
    opacity: 0.18,
    style: {
      isolation: "isolate"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M296.59,215.17s4.5,11.33-19.13,18.35-36.6,34.79-36.09,58.15v15.06s73.48,27,135.79,2.08c0,0,6-63.09-36.6-77.89,0,0-8.83-2.6-6.24-13,0,0,20.26-11.43,16.62-41.55s-15.21-39.47-27.17-40.15C275.47,133.47,275.3,196.82,296.59,215.17Z",
    transform: "translate(-0.75 -37.61)",
    fill: "#f7af87"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M383,308.29s.9-44-6.41-58.94c-6.17-12.63-22.09-15.87-35.53-20a5.39,5.39,0,0,0-2.34-.32,6.25,6.25,0,0,0-2.64,1.42,37.26,37.26,0,0,1-49.42-4.11c-16.12,4.91-28.73,4.81-37.19,19.39s-12.65,43.05-11.06,59.83C238.37,305.57,311,335,383,308.29Z",
    transform: "translate(-0.75 -37.61)",
    fill: "#2c7be5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M255.44,246.14s12.2-12.51,17.11-12.57,35,85.29,35,85.29l-44.91-2.14Z",
    transform: "translate(-0.75 -37.61)",
    fill: "url(#linear-gradient)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M281.75,140.88c2.81-9.34,9.79-18,19.3-20.17,2.84-.65,5.77-.7,8.63-1.25,1.74-.34,3.44-.85,5.16-1.28a40.7,40.7,0,0,1,21.49.2,29.68,29.68,0,0,1,16.95,12.85c3.52,6,4.51,13.16,4,20.08s-4.52,19.18-6.41,25.85c-3.36-4.4-1.12-16.88-5.82-19.82-3.34-2.09-7.64-1.14-11.53-.48a66.1,66.1,0,0,1-27.15-1c-4.21-1.06-8.53-2.54-12.78-1.68-3.69.74-5,3.57-7,6.71-1.42,2.17-2.27,13-3.48,15.11-2.82-1-3.37-18.16-3.34-20.63A52.27,52.27,0,0,1,281.75,140.88Z",
    transform: "translate(-0.75 -37.61)",
    fill: "#404040"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M353.49,174.28a4.56,4.56,0,0,1,3.37-1.25,3.22,3.22,0,0,1,2.2,1.71,6.66,6.66,0,0,1,.68,2.78,15.08,15.08,0,0,1-3.52,10.61c-1.37,1.6-3.41,3-5.46,2.51a2,2,0,0,1-1.08-.57,2.59,2.59,0,0,1-.48-.95,19.42,19.42,0,0,1-.16-9.25c.23-1.33.36-2.63,1.48-3.49C351.45,175.66,352.53,175,353.49,174.28Z",
    transform: "translate(-0.75 -37.61)",
    fill: "#f7af87"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M149,220.05c1.58-.26,3.3-.61,4.33-1.83a6.92,6.92,0,0,0,1.23-3.68c1.93-14.51,7.3-57.26-7-81.76-2-3.5-7.16-4.31-9.94-7-6.52-6.4-14.87-14.16-26.41-14.08-27.66.19-40.25,13.88-51.58,39.12-6.88,15.31-9,61.68-3.3,66.17,6,4.73,21.8,4.35,29.24,5.09A244.23,244.23,0,0,0,149,220.05Z",
    transform: "translate(-0.75 -37.61)",
    fill: "#404040"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M137.25,148.82a5.87,5.87,0,0,1,2-1.73c2.33-1.14,5.15.2,7,2a18.79,18.79,0,0,1,4.7,8.82,44.46,44.46,0,0,1,1,10q.09,6.19-.38,12.38a58.19,58.19,0,0,1-3.76,17.73c-2.33,5.61-6.14,10.74-11.36,13.83-3.88-13.88-4.24-28.46-4.57-42.86-.06-2.29-.11-4.57-.06-6.85,0-.9-.25-2.64.18-3.44s1.2-.64,1.9-1.17c1.11-.83.92-2.37,1.17-3.63A14.19,14.19,0,0,1,137.25,148.82Z",
    transform: "translate(-0.75 -37.61)",
    fill: "url(#linear-gradient-2)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64,178.4a6.47,6.47,0,0,0-2.83,1.11,6.22,6.22,0,0,0-1.63,2.34,24.08,24.08,0,0,0,1,21.9s4.71-5.05,5.12-5.57a46.53,46.53,0,0,0,4.3-6.7c1.13-2.15,7.06-12.12,4.07-13.35C72.14,177.36,66.28,177.92,64,178.4Z",
    transform: "translate(-0.75 -37.61)",
    fill: "url(#linear-gradient-3)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M70.77,215.17c-2.19-5.07-1.75-10.86-1-16.33.67-4.76,1.64-9.66,4.43-13.57a21.4,21.4,0,0,1,10.25-7.37A46,46,0,0,1,97,175.6a108.84,108.84,0,0,1,18.41.3,38.49,38.49,0,0,1,12.5,3,25.69,25.69,0,0,1,12.16,12.58,31.79,31.79,0,0,1,2.37,17.47A13.56,13.56,0,0,1,139.8,216a14,14,0,0,1-6.53,3.78c-9,2.88-18.54,2.66-27.86,2.29-7.73-.3-15.54.14-23.15-1.36C77.8,219.84,72.81,219.91,70.77,215.17Z",
    transform: "translate(-0.75 -37.61)",
    fill: "url(#linear-gradient-4)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M166.35,308.8C104,333.73,30.56,306.72,30.56,306.72v-15C30,268.3,43,240.52,66.65,233.52s22-15.19,22-15.19c-21.28-18.34-24-84.85,24.33-82.09,12,.68,23.55,10,27.17,40.16s-20,43.33-20,43.33a7.91,7.91,0,0,0,3,8,18.1,18.1,0,0,0,6.6,3.21C172.3,245.71,166.35,308.8,166.35,308.8Z",
    transform: "translate(-0.75 -37.61)",
    fill: "#f7af87"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M86.71,180.22c9.42,0,18.94-1.35,27.57-5.11S130.6,165,135,156.69a19.39,19.39,0,0,0,2.51-8.52c.11-5.66-3.48-10.95-8.25-14s-10.54-4.15-16.19-4.39c-12.17-.51-24.74,2.92-34,10.83a37,37,0,0,0-13,26.23C65.62,177.82,77.73,180.21,86.71,180.22Z",
    transform: "translate(-0.75 -37.61)",
    fill: "#404040"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M172.14,308.29s-4.75-35.91-12.06-50.88c-6.17-12.63-16.45-23.93-29.89-28.05a5.37,5.37,0,0,0-2.34-.32,6.16,6.16,0,0,0-2.63,1.42,37.26,37.26,0,0,1-49.42-4.11,66.75,66.75,0,0,0-38.13,30.51C29.21,271.43,26,288.79,27.55,305.57,27.55,305.57,100.13,335,172.14,308.29Z",
    transform: "translate(-0.75 -37.61)",
    fill: "#2c7be5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M120.3,317.79s-27.67,3.07-33.29.26c0,0,14-75.25,47.32-86.08,0,0,14.44,2.4,25.75,25.44C163.37,264.1,120.3,317.79,120.3,317.79Z",
    transform: "translate(-0.75 -37.61)",
    fill: "url(#linear-gradient-5)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M120.38,333.56V288s10.91-41,48.82-45.7,78.93,1.56,78.93,1.56,40,5.19,47.25,54.52v38.95S194.64,366.45,120.38,333.56Z",
    transform: "translate(-0.75 -37.61)",
    fill: "#2c7be5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M170.58,189.4c-1.62-1-3.61-1.69-5.39-1a5.15,5.15,0,0,0-1.93,1.33c-2.81,3-2.65,7.67-1.76,11.67a44.46,44.46,0,0,0,2,6.59,10,10,0,0,0,1.49,2.76c2,2.37,5.5,2.69,8.58,2.33,1.82-.21,3.85-.76,4.68-2.4a5.44,5.44,0,0,0,.48-2C179.56,200.59,177.66,193.68,170.58,189.4Z",
    transform: "translate(-0.75 -37.61)",
    fill: "#f7af87"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M246.84,192.68c2.27-1.58,5.22-2.8,7.77-1.7a6.42,6.42,0,0,1,3.51,5.32,14.85,14.85,0,0,1-1.14,6.52,21.92,21.92,0,0,1-4.05,7.23,10.88,10.88,0,0,1-7.2,3.76,7.33,7.33,0,0,1-6.95-3.7,12,12,0,0,1-.92-5.13,9.93,9.93,0,0,1,.45-4C239.41,198.23,244.51,194.3,246.84,192.68Z",
    transform: "translate(-0.75 -37.61)",
    fill: "#f7af87"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M184.51,246.71a11.37,11.37,0,0,0-1.52,5,8.71,8.71,0,0,0,.74,3c3.66,9,11.24,13.54,18.55,15.64a24.65,24.65,0,0,0,6.77,1.11c6.9,0,13.72-4.74,17.87-12.39a3.15,3.15,0,0,0,.45-1.29,3.65,3.65,0,0,0-.49-1.69c-2.58-5.56-2.11-12.73-1.43-19.26a3.26,3.26,0,0,0-.1-1.62,1.66,1.66,0,0,0-1-.83c-4.47-1.88-9.27-.71-14-.89-6.5-.24-12.8-3.23-19.31-3.24-2.9,0-3.12,1.08-3.53,4.71A37.78,37.78,0,0,1,184.51,246.71Z",
    transform: "translate(-0.75 -37.61)",
    fill: "#f7af87"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M184.59,228s3.75,14.7,12.84,24.33,30.61,7.79,28.07-.81c-2.14-7.21,1.87-23.52,1.87-23.52Z",
    transform: "translate(-0.75 -37.61)",
    fill: "url(#linear-gradient-6)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M281.69,173.73c-1-1-2.17-2-3.58-2.09a3.69,3.69,0,0,0-2.87,1.38,6.61,6.61,0,0,0-1.33,3,15.91,15.91,0,0,0,.61,7.94c1,3.12,2.79,6.28,5.83,7.47a3.38,3.38,0,0,0,3.31-.21,4,4,0,0,0,1.15-2.44C286,182.89,286.19,178.11,281.69,173.73Z",
    transform: "translate(-0.75 -37.61)",
    fill: "#f7af87"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M244.49,200.28c-2.87,24.11-16.27,44-36.35,44s-36.35-19.69-36.35-44,12.91-51.72,33-51.72S250.36,151,244.49,200.28Z",
    transform: "translate(-0.75 -37.61)",
    fill: "#f7af87"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M166.31,192.33q-2-14.31-2.63-28.78c-.18-4.25-.11-9,2.74-12.13a13.46,13.46,0,0,0,2-2.29,9.08,9.08,0,0,0,.77-3.4c1.08-9.11,7.67-16.72,15.23-21.91a58.47,58.47,0,0,1,27.89-10,32.11,32.11,0,0,1,9.64.41,34.62,34.62,0,0,1,9.1,3.65c4.52,2.45,8.87,5.41,12.08,9.42s5.18,9.22,4.5,14.31a17,17,0,0,1,9.43,10.22,35.37,35.37,0,0,1,1.38,14.59c-1,11.68-5.44,23.67-14.76,30.77a51.07,51.07,0,0,0-5.28-23.57,85.28,85.28,0,0,1-3.77-7.68,23.56,23.56,0,0,1-1.52-8.79c-3.9,2.08-6.19,6.34-9.87,8.8a21.21,21.21,0,0,1-7.68,2.81,57.93,57.93,0,0,1-26.38-.92c-3.4-.92-7.73-1.88-9.87.92-1.33,1.73-1.1,4.13-1.28,6.31a30.58,30.58,0,0,1-1.71,6.95l-5.3,16C169.22,196.49,166.65,194.68,166.31,192.33Z",
    transform: "translate(-0.75 -37.61)",
    fill: "#404040"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M123.31,228.16c-16.81,10.77-28.52-7.49-29.06-8.4a26.46,26.46,0,0,0,25.84,0,7.91,7.91,0,0,0,3,8Z",
    transform: "translate(-0.75 -37.61)",
    fill: "url(#linear-gradient-7)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M281.54,184.56c-.7-.91-1.44-2-1.1-3.12s1.52-1.7,1.53-2.78a2.18,2.18,0,0,0-.85-1.57,3.48,3.48,0,0,0-2.09-.91,1.37,1.37,0,0,0-.77.17,1.58,1.58,0,0,0-.57.77c-1.17,2.62-.78,5.7.25,8.38a4.25,4.25,0,0,0,.79,1.39,4,4,0,0,0,1.74.93c1,.32,2.18.33,2.41-.92C283.05,186,282,185.2,281.54,184.56Z",
    transform: "translate(-0.75 -37.61)",
    fill: "url(#linear-gradient-8)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M352.75,184.76c.7-.91,1.44-2,1.1-3.12s-1.52-1.7-1.54-2.78a2.2,2.2,0,0,1,.86-1.57,3.43,3.43,0,0,1,2.09-.91,1.33,1.33,0,0,1,.76.17,1.6,1.6,0,0,1,.58.77c1.16,2.62.77,5.7-.26,8.38a3.18,3.18,0,0,1-2.52,2.32c-1,.32-2.18.33-2.42-.92C351.24,186.22,352.25,185.4,352.75,184.76Z",
    transform: "translate(-0.75 -37.61)",
    fill: "url(#linear-gradient-9)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M244.55,203.75a4.71,4.71,0,0,0,3.15-.76,3.31,3.31,0,0,0,1.23-1c.82-1.29-.08-3.08.51-4.48a3.79,3.79,0,0,1,2.81-1.88,2,2,0,0,1,1.26,0,2.09,2.09,0,0,1,.92,1.88,12.44,12.44,0,0,1-2.84,8.74,11.61,11.61,0,0,1-8.18,4.1.84.84,0,0,1-.47-.07.77.77,0,0,1-.32-.46,5.48,5.48,0,0,1,1-5.37",
    transform: "translate(-0.75 -37.61)",
    fill: "url(#linear-gradient-10)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M166.16,199.62c.46.77,1.39,1.07,2.16,1.52a5.33,5.33,0,0,1,2.58,4.45,2.78,2.78,0,0,1-1.7,2.84c-1.11.31-2.22-.48-3-1.33a11.48,11.48,0,0,1-2.92-8.29c.06-1,.49-3.52,2.09-3C166.65,196.26,165.54,198.58,166.16,199.62Z",
    transform: "translate(-0.75 -37.61)",
    fill: "url(#linear-gradient-11)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M169.77,169.05a9.8,9.8,0,0,0-1.83,5.06,35.42,35.42,0,0,0,.28,7.9l1.51,13.59c1.88-6.5,6.32-12.17,7.33-18.86.32-2.13.26-4.35.94-6.41.3-.9,2.08-3.12,1.42-4s-4.45-.18-5.44.1A8.17,8.17,0,0,0,169.77,169.05Z",
    transform: "translate(-0.75 -37.61)",
    fill: "url(#linear-gradient-12)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M244.44,146.36a.81.81,0,0,1,.5-.1c.22.05.35.26.47.46,2.3,3.93,4.64,7.94,5.65,12.39a29.88,29.88,0,0,1,.63,7.49,45.36,45.36,0,0,1-7.55,23.71c-.94-3.11-.84-6.45-1.59-9.62-1-4.3-3.51-8.07-5.7-11.91-2-3.5-5.49-9.41-2.95-13.23A24,24,0,0,1,244.44,146.36Z",
    transform: "translate(-0.75 -37.61)",
    fill: "url(#linear-gradient-13)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M296.59,215.17s5.69,6.94,18.07,7.31c13.36.4,19.66-4.54,19.66-4.54s-5.89,13-20.6,15.9c-9.31,1.86-19.78-2.14-21.65-7C292.07,226.89,298.17,221.22,296.59,215.17Z",
    transform: "translate(-0.75 -37.61)",
    fill: "url(#linear-gradient-14)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M184.86,242.93s3.61,17.24,16.44,21.25,23.66-8.82,24.06-17.24,2.41-6,2.41-6l3.21,2v31.68L206.52,271l-24.06,6.82s-6.42-28.88-2.81-36.9",
    transform: "translate(-0.75 -37.61)",
    fill: "#2c7be5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGroup);
export default __webpack_public_path__ + "static/media/user-group.8c6639379d268151a41849de023eaf4d.svg";
export { ForwardRef as ReactComponent };